import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import p1 from "../../assets/img/Semi2.jpg"
import p2 from "../../assets/img/Car1.jpeg"
import { Grid } from '@mui/material';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
 height:500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function CampaignPhotos({open,close}) {
  const[img,setImage]=React.useState(p2)

  return (
    <div>
    
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <Grid item xs={12} >
        <div style={{padding:"20px"}}>
            <img src={img} style={{height:"300px",width:"100%",objectFit:"cover"}} />
            <div className='d-flex gap-3 ' style={{padding:"10px"}}>
            <img src={p2} style={{height:"100px",width:"100px",objectFit:"cover"}}/>
            <img src={p2} style={{height:"100px",width:"100px",objectFit:"cover"}}onClick={()=>setImage(p2)}/>
            <img src={p1} style={{height:"100px",width:"100px",objectFit:"cover"}} onClick={()=>setImage(p1)}/>
            <img src={p2} style={{height:"100px",width:"100px",objectFit:"cover"}}/>
            </div>
        </div>
        
       </Grid>
        </Box>
      </Modal>
    </div>
  );
}